import { gql } from '@apollo/client';

export const FETCH_TIMELINE = gql`
	query crewMemberTimeline($filter: CrewMemberTimelineFilter!, $pagination: PaginationInput!) {
		crewMemberTimeline(filter: $filter, pagination: $pagination) {
			results {
				id
				fullName
				driverCard
				crewMember {
					currentLocation {
						city {
							name
						}
						station {
							name
							code
						}
						fromTimestamp
					}
					currentHomeBase {
						city {
							name
						}
					}
					lastWorkAssignment {
						activity {
							__typename
							... on CrewMemberWorkAssignmentActivityItem {
								activityType
								toStation {
									code
									city {
										name
									}
								}
							}
						}
					}
					availabilityInfo {
						idleTimeMinutes
						status
						currentActivity {
							activity {
								__typename
								... on CrewMemberWorkAssignmentActivityItem {
									status
									activityType
									toStation {
										code
										name
										city {
											id
											name
										}
									}
								}
								... on CrewMemberAbsenceActivityItem {
									note
									reason {
										name
										id
									}
								}
								... on CrewMemberBreakActivityItem {
									breakType
								}
							}
						}
					}
					currentRun {
						id
						name
					}
				}
				activitiesV2 {
					fromTimestamp
					toTimestamp
					activity {
						__typename
						... on CrewMemberWorkAssignmentActivityItem {
							title
							status
							activityType
							rideId
							sequenceGroupId
							shiftId
							fromStation {
								code
								id
								timezone
								name
								city {
									id
									name
								}
							}
							toStation {
								code
								id
								timezone
								name
								city {
									id
									name
								}
							}
							firstWorkAssignmentId
							firstWorkAssignmentVersion
							note
							extraActivities {
								id
								version
								fromTimestamp
								toTimestamp
								activityType
								status
								fromStation {
									id
									code
									name
									timezone
									city {
										id
										name
									}
								}
								toStation {
									id
									code
									name
									timezone
									city {
										id
										name
									}
								}
								sequenceGroupId
							}
						}
						... on CrewMemberAbsenceActivityItem {
							id
							note
							reason {
								name
								id
							}
							availableForAssignments
						}
						... on CrewMemberBreakActivityItem {
							breakType
						}
					}
				}
				shifts {
					id
					fromTimestamp
					toTimestamp
					autoCloseTimestamp
				}
			}
			page {
				size
				page
			}
		}
	}
`;
